import React from 'react';
import styles from './ResetButton.module.css';

const HintButton = ({ onClick, disabled, title = 'Help' }) => {
  return (
    <button
      className={styles.resetButton}
      onClick={onClick}
      disabled={disabled}
      title={title}
    >
      <svg fill="none" height="15" viewBox="0 0 15 15" width="15" xmlns="http://www.w3.org/2000/svg" >
		  <path d="M5.40383 4.69657L2.56193 1.85467C5.38341 -0.618251 9.61671 -0.618224 12.4382 1.85475L9.59627 4.69664C8.35737 3.76781 6.64275 3.76779 5.40383 4.69657Z" fill="#FF3B30"/>
		  <path d="M10.3034 5.40375C11.2322 6.64267 11.2322 8.35732 10.3034 9.59624L13.1453 12.4381C15.6182 9.61666 15.6182 5.38333 13.1453 2.56186L10.3034 5.40375Z" fill="#FF3B30"/>
		  <path d="M9.59627 10.3034C8.35738 11.2322 6.64277 11.2322 5.40384 10.3034L2.56195 13.1453C5.38343 15.6183 9.61672 15.6182 12.4382 13.1452L9.59627 10.3034Z" fill="#FF3B30"/>
		  <path d="M4.6967 5.40366C3.76776 6.64262 3.76777 8.3574 4.69671 9.59636L1.85483 12.4382C-0.618272 9.61674 -0.618276 5.38328 1.85481 2.56177L4.6967 5.40366Z" fill="#FF3B30"/>
	  </svg>
    </button>
  );
};

export default HintButton;